module.exports = {
  // 正式服务器
  api: {
    host: 'api.beijinglu.yuexiu.gov.cn',
    port: '',
    protocol: 'http'
  },
  return: 'http://112.94.67.15'
}
